import gql from 'graphql-tag';

export interface UserSavedMerchantProductOffer {
    userId: string;
    merchantProductOfferId: string;
    savedAt: number;
    originalTitle: string;
    processedWebpageUrl: string;
    mainImageUrls: {
        defaultSize: string;
    };
    displayPriceAmount: {
        currency: string;
        valueInCents: number;
    };
    merchantId: string;
}

export interface UserSavedMerchantProductOffersQueryResponse {
    __typename: 'Query';
    user: {
        __typename: 'User';
        savedMerchantProductOffers: UserSavedMerchantProductOffer[];
    };
}

export const userSavedMerchantProductOffersQuery = gql`
    query UserSavedMerchantProductOffers {
        user {
            savedMerchantProductOffers {
                userId
                merchantProductOfferId
                savedAt
                originalTitle
                processedWebpageUrl
                mainImageUrls {
                    defaultSize
                }
                displayPriceAmount {
                    currency
                    valueInCents
                }
                merchantId
            }
        }
    }
`;
